const symbolCache: { [currencyCode: string]: string } = {};

// Symbols are derived from Intl rather than a hand maintained lookup so that they always
// match the currency formatting Intl produces elsewhere in the app (see StoneXNumber).
function resolveSymbol(currencyCode: string): string {
  if (Object.prototype.hasOwnProperty.call(symbolCache, currencyCode)) {
    return symbolCache[currencyCode];
  }

  let symbol = '';

  try {
    symbol = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'symbol',
    })
      .formatToParts(0)
      .filter((part) => part.type === 'currency')
      .map((part) => part.value)
      .join('');
  } catch (error) {
    // Codes that are not well formed ISO 4217 values, such as 'FX', cannot be formatted.
    symbol = '';
  }

  symbolCache[currencyCode] = symbol;
  return symbol;
}

export class CurrencyHelper {
  public static isFormattable(currencyCode?: string | null): boolean {
    return !!currencyCode && resolveSymbol(currencyCode) !== '';
  }

  public static getSymbol(currencyCode?: string | null): string {
    return currencyCode ? resolveSymbol(currencyCode) : '';
  }

  /** Returns the currency shared by every code supplied, or null when they are mixed or absent. */
  public static getCommonCurrency(currencyCodes: (string | null | undefined)[]): string | null {
    const distinctCodes = currencyCodes
      .filter((code): code is string => !!code)
      .filter((code, index, allCodes) => allCodes.indexOf(code) === index);

    return distinctCodes.length === 1 ? distinctCodes[0] : null;
  }
}
